
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TextEditorAttributes = (function () {

    function TextEditorAttributes() {

        Monet.UI.Fields.TextAreaAttributes.apply(this, arguments);

        this.createBaseStructure();

        this.listAttributesContent = null;
        this.listBlocksContent = null;
        this.quill = null;
        this.cursorPosition = -1;

        this.createElement = function () {
            this.rootEl.className = 'textEditorAttributes';

            const textEditorAttributes = document.createElement('div');
            textEditorAttributes.className = 'textAreaContent';
            const textEditorContent = document.createElement("div");
            textEditorAttributes.appendChild(textEditorContent);

            const toolbarOptions = [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ color: [] }, { background: [] }],
                [{ align: [] }]
            ];
            this.quill = new Quill(textEditorContent, {
                modules: {
                    toolbar: toolbarOptions
                },
                theme: 'snow'
            });

            this.quill.on('text-change', (ev) => {
                ev.ops.forEach(op => {
                    if (op.insert) {
                        this.cursorPosition += op.insert.length;
                    } else if (op.delete) {
                        this.cursorPosition -= op.delete;
                    }
                });
            });

            this.quill.on('selection-change', (range) => {
                if (range) {
                    this.cursorPosition = range.index;
                }
            });

            this.listBlocksContent = document.createElement('span');
            this.listBlocksContent.className = "ql-formats blocks-list";

            this.listAttributesContent = document.createElement('span');
            this.listAttributesContent.className = "ql-formats";
            const listAttributes = this.createList();
            this.listAttributesContent.appendChild(listAttributes);

            const toolbar = textEditorAttributes.querySelector('.ql-toolbar');
            toolbar.appendChild(this.listAttributesContent);
            toolbar.appendChild(this.listBlocksContent);

            this.rootEl.appendChild(textEditorAttributes);
        };

        this.getValue = function () {
            if (this.quill) {
                const quillValue = this.quill.root.innerHTML;
                this.value = quillValue;
            }
            return encodeURI(this.value);
        };

        this.appendValue = function (value, isBlockValue) {
            if (value || value === '' || value === 0) {
                const quillText = this.quill.getText();
                const appendPosition = (!isBlockValue && this.cursorPosition) ? this.cursorPosition : quillText.length - 1;
                const valueToAppend = (quillText.length === 1 || quillText[appendPosition - 1] === " ") ? value : ` ${value}`;
                if (isBlockValue) {
                    this.quill.clipboard.dangerouslyPasteHTML(appendPosition, value);
                } else {
                    this.quill.insertText(appendPosition, valueToAppend, '', true);
                }
                this.getValue();
            }
            this.setInputValue();
        }

        this.setValue = function (value) {
            if (value || value === '' || value === 0) {
                this.value = decodeURI(value);
            }
            this.setInputValue();
        };

        this.setInputValue = function () {
            if (this.quill) {
                this.quill.container.firstElementChild.innerHTML = this.value;
            }
        };

        this.setAttributes = function (attributes) {
            this.attributes = attributes;
            this.listAttributesContent.innerHTML = "";
            this.listAttributesContent.appendChild(this.createList());
        };

        this.clear = function() {
            this.setValue('');
            this.setAttributes([]);
            this.blocks = [];
            this.listBlocksContent.innerHTML = "";
        };

        // Blocks

        this.renderBlockFieldList = function () {
            var fragment = document.createDocumentFragment();
            var select = document.createElement('select');
            select.className = 'pickListFieldFilters';
            select.setAttribute('data-live-search', 'true');
            select.setAttribute('title', Monet.I18n.getResourcesByKey('SelectKeyResource.block.add'));

            for (var block in this.blocks) {
                select.appendChild(this.createOptionElement(this.blocks[block]));
            }
            fragment.appendChild(select);

            return fragment;
        };

        this.createBlockPicklist = function () {
            let content = document.createElement("div");
            content.className = "attributesContent";
            
            const fieldListElement = this.renderBlockFieldList();
            content.appendChild(fieldListElement);
            const pickList = $(content.querySelector('.pickListFieldFilters'));
            pickList.selectpicker({
                callback: (val) => {
                    let value = `[${val}]<br>`;
                    value += `<span style="color: rgb(142, 142, 142);">${Monet.I18n.getResourcesByKey('SelectKeyResource.block.replaceText')}</span><span> </span><br>`;
                    value += `[${val}]<br><p> </p>`;                    
                    this.appendValue(value, true);

                    pickList.selectpicker('val', 'default');
                    pickList.selectpicker('refresh');
                },
                liveSearchNormalize: true
            });

            pickList.selectpicker('val', 'default');
            pickList.selectpicker('refresh');
            pickList.selectpicker('show');
            return content;
        };

        this.setBlocks = function (blocks) {
            this.blocks = blocks;
            this.listBlocksContent.innerHTML = "";
            this.listBlocksContent.appendChild(this.createBlockPicklist());
        };
    }

    return TextEditorAttributes;

}());